<div class="overlay-prompt-comp">
  <div>Question</div>
  <div class="flex-row gap-6">
    <div class="answer" (click)="answer(true)">Yes</div>
    <div class="answer" (click)="answer(false)">No</div>
  </div>
</div>
